import { Link } from "react-router-dom";
import { FadeUp } from "@/components/Reveal";
import { Magnetic } from "@/components/Magnetic";

export const RfqCta = () => (
  <section className="relative py-20 lg:py-28 bg-midnight overflow-hidden" data-testid="rfq-cta-section">
    <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)", backgroundSize: "80px 80px" }} />
    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[36rem] h-[36rem] rounded-full bg-gold/10 blur-3xl pointer-events-none" />
    <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
      <FadeUp>
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold mb-6">Secure Supply</p>
        <h2 className="font-heading text-4xl md:text-6xl font-light tracking-tight text-white max-w-4xl leading-[1.05]">
          When compute matters, <span className="gold-text-gradient font-medium">supply matters.</span>
        </h2>
        <p className="text-white/60 text-lg mt-8 max-w-2xl leading-relaxed">
          Hardware availability can determine whether an AI project moves today or months from now. Royal Deals FZ-LLC works across international technology supply channels to identify commercially viable availability for qualified buyers.
        </p>
        <div className="flex flex-wrap gap-4 mt-12">
          <Magnetic>
            <Link
              to="/request"
              data-testid="cta-submit-requirement"
              className="inline-block bg-gold text-midnight text-sm font-semibold px-10 py-4 hover:bg-gold-light transition-colors"
            >
              Submit Requirement
            </Link>
          </Magnetic>
          <Magnetic>
            <Link
              to="/contact"
              data-testid="cta-contact-us"
              className="inline-block border border-white/30 text-white text-sm font-medium px-10 py-4 hover:border-gold hover:text-gold transition-colors"
            >
              Contact Us
            </Link>
          </Magnetic>
        </div>
      </FadeUp>
    </div>
  </section>
);
